import { LouisEventType } from './LouisEventType';
import { IBaseEvent } from './IBaseEvent';
import { IEECEcommerceClickEvent } from './IEECEcommerceClickEvent';

export class IProductClickEvent implements IBaseEvent {
    public readonly name = LouisEventType.CLICK_EVENT;
    constructor(public payload: IEECEcommerceClickEvent) { }
}
